import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { CONFIG } from '../../environments/config';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private httpClientService: HttpClientService) { }

  public getAllCustomers(data: any){
    return this.httpClientService.post(`${CONFIG.CUSTOMER.GETALLCUSTOMER}`,data);
  }

  public getContactByCustomer(data: any){
    return this.httpClientService.post(`${CONFIG.CONTACT.GETCONTACTBYCUSTOMER}`,data);
  }
  public getContactBySalesperson(data: any){
    return this.httpClientService.post(`${CONFIG.CONTACT.GETCONTACTBYSALESPERSON}`,data);
  }

  public getContactByVendor(data: any){
    return this.httpClientService.post(`${CONFIG.CONTACT.GETCONTACTBYVENDOR}`,data);
  }

  public createContact(data: any) {
    return this.httpClientService.post(`${CONFIG.CONTACT.CREATECONTACT}`,data);
  }
  public updateContact(data: any) {
    return this.httpClientService.post(`${CONFIG.CONTACT.UPDATE_CONTACT}`,data);
  }

  public getContactByID(data: any)
  {
    let queryParam = `id=${data}`;
    return this.httpClientService.get(`${CONFIG.CONTACT.GET_CONTACT_BYID}?${queryParam}`);
  }

  public updateCustomer(data: any) {
    return this.httpClientService.post(`${CONFIG.CUSTOMER.UPDATECUSTOMER}`,data);
  }

  public deleteContact(data: any) {
    return this.httpClientService.post(`${CONFIG.CONTACT.DELETECONTACT}`,data);
  }
    public getCRMContact(data: any){
    return this.httpClientService.post(`${CONFIG.CONTACT.GETCRMCONTACT}`,data);
  }
    public searchCRMContact(seachkey:string){
    return this.httpClientService.get(`${CONFIG.CONTACT.AUTOSEARCHCRMCONTACT}?searchText=${seachkey}`);
  }
}
